import { useGetCurrentUserQuery, useGetFolderQuery } from '@carboncopyco/data';
import { MoreVerticalOutlineIcon, PlusOutlineIcon } from '@carboncopyco/icons';
import {
  PermissionAction,
  PermissionKey,
  type Role,
} from '@carboncopyco/types';
import { Button } from '@carboncopyco/ui';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePermissionsContext } from '../../../../utils';
import { useWorkspacePageProps } from '../../WorkspacePageContext';
import { WorkspacePageCreateMenu } from '../../WorkspacePageCreateMenu';
import { WorkspacePageHeader } from '../../WorkspacePageHeader';
import { FolderPageHeader } from '../FolderPageHeader';
import { FolderActions } from '../FolderTiles';
import { FolderPageBody } from './FolderPageBody';

export const FolderPage = () => {
  const { folderId, workspaceId } = useParams();
  const navigate = useNavigate();
  const { data: userData } = useGetCurrentUserQuery();
  const { organizationId, setFolderId, rootPath } = useWorkspacePageProps();
  const { data: folder } = useGetFolderQuery({
    organizationId,
    folderId,
    workspaceId,
  });
  const { getPermissions } = usePermissionsContext();

  const userRole: Role = userData?.user?.roles?.[organizationId] || 'presenter';

  const updateFolderByIdPermission = getPermissions(
    PermissionKey.folder,
    PermissionAction.updateFolderById
  );

  const deleteFolderByIdPermission = getPermissions(
    PermissionKey.folder,
    PermissionAction.deleteFolderById
  );

  useEffect(() => {
    setFolderId(folderId);
  }, [folderId, setFolderId]);

  return (
    <>
      <WorkspacePageHeader>
        <div className="flex flex-col w-10/12">
          <FolderPageHeader folder={folder} />
        </div>
        {folder && !folder.readOnly && (
          <div className="flex gap-4">
            {(updateFolderByIdPermission || deleteFolderByIdPermission) &&
              folder && (
                <FolderActions
                  folderId={folderId}
                  folderName={folder.name}
                  onArchiveSuccess={() => navigate(rootPath)}
                  align="center"
                  triggerElement={
                    <Button
                      secondary
                      icon={<MoreVerticalOutlineIcon />}
                      aria-label="more actions menu"
                    />
                  }
                />
              )}
            {userRole !== 'presenter' && (
              <WorkspacePageCreateMenu
                asChild
                triggerElement={
                  <Button
                    label="Create new"
                    leftIcon={<PlusOutlineIcon />}
                  />
                }
                location="folder_page"
              />
            )}
          </div>
        )}
      </WorkspacePageHeader>
      <FolderPageBody folder={folder} />
    </>
  );
};
